import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <circle id="Oval" cx="35" cy="35" r="35" fill="#0088FF" />
        <path
          id="Vector"
          d="M22.9032 27.8065C24.506 27.8065 25.8065 26.506 25.8065 24.9032C25.8065 23.3004 24.506 22 22.9032 22C21.3004 22 20 23.3004 20 24.9032C20 26.506 21.3004 27.8065 22.9032 27.8065ZM30.6452 22.9677C29.5746 22.9677 28.7097 23.8327 28.7097 24.9032C28.7097 25.9738 29.5746 26.8387 30.6452 26.8387H48.0645C49.1351 26.8387 50 25.9738 50 24.9032C50 23.8327 49.1351 22.9677 48.0645 22.9677H30.6452ZM30.6452 32.6452C29.5746 32.6452 28.7097 33.5101 28.7097 34.5806C28.7097 35.6512 29.5746 36.5161 30.6452 36.5161H48.0645C49.1351 36.5161 50 35.6512 50 34.5806C50 33.5101 49.1351 32.6452 48.0645 32.6452H30.6452ZM30.6452 42.3226C29.5746 42.3226 28.7097 43.1875 28.7097 44.2581C28.7097 45.3286 29.5746 46.1935 30.6452 46.1935H48.0645C49.1351 46.1935 50 45.3286 50 44.2581C50 43.1875 49.1351 42.3226 48.0645 42.3226H30.6452ZM22.9032 47.1613C24.506 47.1613 25.8065 45.8609 25.8065 44.2581C25.8065 42.6552 24.506 41.3548 22.9032 41.3548C21.3004 41.3548 20 42.6552 20 44.2581C20 45.8609 21.3004 47.1613 22.9032 47.1613ZM25.8065 34.5806C25.8065 32.9778 24.506 31.6774 22.9032 31.6774C21.3004 31.6774 20 32.9778 20 34.5806C20 36.1835 21.3004 37.4839 22.9032 37.4839C24.506 37.4839 25.8065 36.1835 25.8065 34.5806Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
